import axios from 'axios'

const API_PATH = 'api/v2/admins/sellers/products/price_confirmations'

const SellerProductApiV2 = {
  /**
   * Confirm Seller Price on Seller Product
   * @param {array} price_confirmations - List of price confirmations
   */
  confirm: async ({ price_confirmations }) => {
    const path = `${API_PATH}/confirm`
    const body = {
      price_confirmations: price_confirmations
    }

    const response = await axios.patch(path, body)
    return response
  }
}

export default SellerProductApiV2
